/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum UtmParams {
    SOURCE="utm_source",
    MEDIUM="utm_medium",
    CAMPAIGN="utm_campaign",
    TERM="utm_term",
}